/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { css } from "styled-components";

const countTextStyles = css`
    font-size: 13px;
    line-height: 22px;
    white-space: nowrap;
`;

productCountStyles.wrapper = {};

productCountStyles.countText = {
    css: css`
        ${countTextStyles};

        span {
            font-weight: 700;
        }
    `,
};

productCountStyles.itemsText = {
    css: css`
        ${countTextStyles};
    `,
};

productCountStyles.queryText = {
    css: css`
        ${countTextStyles};
        font-weight: 700;
    `,
};
